import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin-bottom: ${SPACER.x2large};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    padding: 0;
  }
`;

export const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 130%;
  margin-bottom: ${SPACER.xsmall};

  ${MEDIA_QUERIES.mdUp} {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.h4`
  font-size: 1rem;
  font-weight: 400;
  line-height: 150%;
  max-width: 'inherit';

  ${MEDIA_QUERIES.mdUp} {
    font-size: 1rem;
  }
`;

export const buttonStyles = css`
  width: min-content !important;
  white-space: nowrap;
`;
